
function pluralise(word, wordPlural, quantity) {
    if(quantity === 1) {
        return word;
    }
    if(wordPlural === word) {
        return word + 's';
    }
    return wordPlural;
}
